export const getGroupWorkPlaces = (staffProject, targetId) => {
	for (let child of staffProject?.childs || []) {
		if (child.externalId === targetId) {
			return child.positionGroups
		}
		if (Array.isArray(child.childs)) {
			const result = getGroupWorkPlaces(child, targetId)
			if (result) {
				return result
			}
		}
	}
}
